<script >


</script>


	
<div class="learnMoreContainer" id="learnMoreContainer">

	<div class="learnMoreContainerTitle">
		Innovative Bio-interventions and Risk Modelling Approaches for Ensuring Microbial Safety and Quality of Mediterranean Artisanal Fermented Foods
	</div>

	<div class="learnMoreContainerTxt">
		A Project that develops efficient bio-intervention strategies, enhanced process criteria, monitoring and sampling schemes, and an easy-to-use food safety decision support IT tool for participating artisanal food producers, aiming to the reduction and control of food-borne pathogens in artisanal fermented foods of meat or dairy origin produced in mediterranean region.
	</div>

</div>  






<style>


	


@media only screen and (min-width: 768px) {

	.learnMoreContainer{
		width: 100vw;
		min-height: 100vh;
		background-color: transparent;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 10%;
		scroll-snap-align: start;

	}

	.learnMoreContainerTitle{
		width: 67%;
		height: 30%;
		font-style: normal;
		font-weight: 900;
		font-size:  2.0833333333333335vw;
		display: flex;
		color: #EF9144;
		line-height: 130%;
		align-items: center;
		justify-content: center;
		text-transform: capitalize;
		text-align: center;
		text-align-last: center;
		text-decoration: none;
		animation-duration: 4s;
	  	animation-name: aboutTitle;
	  	animation-iteration-count: 1;
	  	animation-timing-function:cubic-bezier(0.0, 0.0, 1.0, 1.0);
	  	transform: scale(1.1, 1.2);
	  	margin-top: 0%;
	}


	.learnMoreContainerTxt{
		width: 80%;
		height: 40%;
		color: #333333;
		font-style: normal;
		font-weight: 700;
		font-size: 1.4322916666666667vw;
		display: flex;
		align-items: center;
		justify-content: center;
		text-transform: none;
		text-align: justify;
		text-align-last: center;
		letter-spacing: 0.03em;
		line-height: 155%;
		animation-duration:4.5s; 
		margin-top: 0%;
	}
}


</style>